import React, { useState } from "react";
import {useNavigate} from 'react-router-dom';
import Select from 'react-select'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';


const options = [
  { value: 'Alamance', label: 'Alamance' },
  { value: 'Alexander', label: 'Alexander' },
  { value: 'Alleghany', label: 'Alleghany' },
  { value: 'Anson', label: 'Anson' },
  { value: 'Ashe', label: 'Ashe' },
  { value: 'Avery', label: 'Avery' },
  { value: 'Beaufort', label: 'Beaufort' },
  { value: 'Bertie', label: 'Bertie' },
  { value: 'Bladen', label: 'Bladen' },
  { value: 'Brunswick', label: 'Brunswick' },
  { value: 'Buncombe', label: 'Buncombe' },
  { value: 'Burke', label: 'Burke' },
  { value: 'Cabarrus', label: 'Cabarrus' },
  { value: 'Caldwell', label: 'Caldwell' },
  { value: 'Camden', label: 'Camden' },
  { value: 'Carteret', label: 'Carteret' },
  { value: 'Caswell', label: 'Caswell' },
  { value: 'Catawba', label: 'Catawba' },
  { value: 'Chatham', label: 'Chatham' },
  { value: 'Cherokee', label: 'Cherokee' },
  { value: 'Chowan', label: 'Chowan' },
  { value: 'Clay', label: 'Clay' },
  { value: 'Cleveland', label: 'Cleveland' },
  { value: 'Columbus', label: 'Columbus' },
  { value: 'Craven', label: 'Craven' },
  { value: 'Cumberland', label: 'Cumberland' },
  { value: 'Currituck', label: 'Currituck' },
  { value: 'Dare', label: 'Dare' },
  { value: 'Davidson', label: 'Davidson' },
  { value: 'Davie', label: 'Davie' },
  { value: 'Duplin', label: 'Duplin' },
  { value: 'Durham', label: 'Durham' },
  { value: 'Edgecombe', label: 'Edgecombe' },
  { value: 'Forsyth', label: 'Forsyth' },
  { value: 'Franklin', label: 'Franklin' },
  { value: 'Gaston', label: 'Gaston' },
  { value: 'Gates', label: 'Gates' },
  { value: 'Graham', label: 'Graham' },
  { value: 'Granville', label: 'Granville' },
  { value: 'Greene', label: 'Greene' },
  { value: 'Guilford', label: 'Guilford' },
  { value: 'Halifax', label: 'Halifax' },
  { value: 'Harnett', label: 'Harnett' },
  { value: 'Haywood', label: 'Haywood' },
  { value: 'Henderson', label: 'Henderson' },
  { value: 'Hertford', label: 'Hertford' },
  { value: 'Hoke', label: 'Hoke' },
  { value: 'Hyde', label: 'Hyde' },
  { value: 'Iredell', label: 'Iredell' },
  { value: 'Jackson', label: 'Jackson' },
  { value: 'Johnston', label: 'Johnston' },
  { value: 'Jones', label: 'Jones' },
  { value: 'Lee', label: 'Lee' },
  { value: 'Lenoir', label: 'Lenoir' },
  { value: 'Lincoln', label: 'Lincoln' },
  { value: 'Macon', label: 'Macon' },
  { value: 'Madison', label: 'Madison' },
  { value: 'Martin', label: 'Martin' },
  { value: 'McDowell', label: 'McDowell' },
  { value: 'Mecklenburg', label: 'Mecklenburg' },
  { value: 'Mitchell', label: 'Mitchell' },
  { value: 'Montgomery', label: 'Montgomery' },
  { value: 'Moore', label: 'Moore' },
  { value: 'Nash', label: 'Nash' },
  { value: 'New Hanover', label: 'New Hanover' },
  { value: 'Northampton', label: 'Northampton' },  
  { value: 'Onslow', label: 'Onslow' },
  { value: 'Orange', label: 'Orange' },
  { value: 'Pamlico', label: 'Pamlico' },
  { value: 'Pasquotank', label: 'Pasquotank' },
  { value: 'Pender', label: 'Pender' },
  { value: 'Perquimans', label: 'Perquimans' },
  { value: 'Person', label: 'Person' },
  { value: 'Pitt', label: 'Pitt' },
  { value: 'Polk', label: 'Polk' },
  { value: 'Randolph', label: 'Randolph' },
  { value: 'Richmond', label: 'Richmond' },
  { value: 'Robeson', label: 'Robeson' },
  { value: 'Rockingham', label: 'Rockingham' },
  { value: 'Rowan', label: 'Rowan' },
  { value: 'Rutherford', label: 'Rutherford' },
  { value: 'Sampson', label: 'Sampson' },
  { value: 'Scotland', label: 'Scotland' },
  { value: 'Stanly', label: 'Stanly' },
  { value: 'Stokes', label: 'Stokes' },
  { value: 'Surry', label: 'Surry' },
  { value: 'Swain', label: 'Swain' },
  { value: 'Transylvania', label: 'Transylvania' },
  { value: 'Tyrrell', label: 'Tyrrell' },
  { value: 'Union', label: 'Union' },
  { value: 'Vance', label: 'Vance' },
  { value: 'Wake', label: 'Wake' },
  { value: 'Warren', label: 'Warren' },
  { value: 'Washington', label: 'Washington' },
  { value: 'Watauga', label: 'Watauga' },
  { value: 'Wayne', label: 'Wayne' },
  { value: 'Wilkes', label: 'Wilkes' },
  { value: 'Wilson', label: 'Wilson' },
  { value: 'Yadkin', label: 'Yadkin' },
  { value: 'Yancey', label: 'Yancey' }
  ]

  const type = [
    { value: 'Civil', label: 'Civil' },
    { value: 'Criminal', label: 'Criminal' }
  ]


function Home() {
  const [selectedOption, setSelectedOption] = useState("none");
  const [selectedOptionB, setSelectedOptionB] = useState("none");
  const handleTypeSelect = e => {
    setSelectedOption(e.value);
  };
  const handleTypeSelectB = e => {
    setSelectedOptionB(e.value);
  };
const resultsUrl = "/results?county=" + selectedOption + '&type=' + selectedOptionB;
const navigate = useNavigate();
const handleSubmit = event => {
  event.preventDefault();
  navigate(resultsUrl);
};

  return (
<main id="content-container" className="content-container" role="main">
<div>
    <div id="block-breadcrumbs">
  
    
    <nav className="breadcrumb" role="navigation" aria-labelledby="system-breadcrumb">
        <div className="breadcrumbs">
            <div className="wrapper">
                <ol itemScope="" itemType="http://schema.org/BreadcrumbList">
                                            <li itemProp="itemListElement" itemScope="" itemType="http://schema.org/ListItem">
                            <span itemScope="" itemType="http://schema.org/Thing" itemProp="item">
                                                                    <a href="https://www.nccourts.gov"><span itemProp="name" title="Go back to: Home">Home</span></a>
                                       
                            </span>
                            <meta itemProp="position" content="1" loop-length="3"/>
                        </li>
                                            <li className="parent" itemProp="itemListElement" itemScope="" itemType="http://schema.org/ListItem">
                            <span itemScope="" itemType="http://schema.org/Thing" itemProp="item">
                                                                    <a href="https://www.nccourts.gov/court-dates"><span itemProp="name" title="Go back to: Court Dates">Court Dates</span></a>
                                       
                            </span>
                            <meta itemProp="position" content="2" loop-length="3"/>
                        </li>
                                            <li itemProp="itemListElement" itemScope="" itemType="http://schema.org/ListItem">
                            <span itemScope="" itemType="http://schema.org/Thing" itemProp="item">
                                                                    <span itemProp="name" title="Currently viewing: Civil & Criminal Calendars"> Civil & Criminal Calendars</span>
                                   
                            </span>
                            <meta itemProp="position" content="3" loop-length="3"/>
                        </li>
                                    </ol>
            </div>
        </div>
    </nav>

  </div>

  </div>
  <article itemScope itemType="http://schema.org/WebPage">
    <header className="title title--primary" >
      <div className="wrapper">
        <h1 className="title__label" itemProp="headline">Civil and Criminal Calendars</h1>
        <p className="title__description" itemProp="description">Select a county and calendar type from the pull down menu to access calendars.</p>
      </div>
    </header>
    <div id="block-tyler-vs-legacy">  
  <div className="zone" itemProp="mainContentOfPage">
<section className="band" data-columns="1" data-theme="default"><div className="wrapper">
<div className="band__part">
<div className="alert alert--secondary" role="alert">
<p><a href="https://www.nccourts.gov/portal">Portal is recommended for searching court dates and case information</a>.</p>
</div>
</div>
</div>
</section></div>


  </div>
    <div className="zones">
      <div className="zone" itemProp="mainContentOfPage">
	          <div className="band">
          <div className="wrapper">
            <div className="band__parts">
              <div className="band__part">
<Form onSubmit={handleSubmit} className="form form--filter-panel" id="calendarSelect">
  <fieldset>
  <div className="js-form-item form-item js-form-type-select form-item-field-form-type-target-id js-form-item-field-form-type-target-id formblock">
  <div>
  <label type="select" htmlFor="county-list" className="formblock__label">County</label>
    <Select required name="county-list" id="countyname" options={options}
        onChange={handleTypeSelect}
        value={options.filter(function(option) {
          return option.value === selectedOption;
        })} placeholder="-- Select County --" / >
</div>
<br/>
<div>
<label type="select" htmlFor="type-list" className="formblock__label">Calendar Type</label>
    <Select required name="type-list" id="calendartype" options={type}
        onChange={handleTypeSelectB}
        value={type.filter(function(option) {
          return option.value === selectedOptionB;
        })} placeholder="-- Select Calendar Type --" / >
          </div>
          </div>
          <div className="form-actions js-form-wrapper form-wrapper">
    <Button type="submit" className="button submit-button">
                    Search
                  </Button>
                  </div>
                  </fieldset>
                  </Form>
                  </div>
                  </div>
                  </div>
                  </div>
                  <div className="band">
          <div className="wrapper">
            <div className="band__parts">
              <div className="band__part">
<h5>Disclaimer</h5>
<p>Some counties do not post and update criminal and civil calendars to this website. If you cannot find the calendar you are looking for or if you have any questions regarding the calendars for a particular county, please read the <a href="https://www.nccourts.gov/documents/local-rules-and-forms">local rules</a> for that county to determine which office maintains the calendars in question.
								</p>
                </div>
                </div>
                </div>
                </div>
                  </div>
                  </div>
  </article>
</main>
  )
}

export default Home;
